import React, { useEffect, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import mapPageJSON from '../page-json-mapper/pageJSONMapper';
import PageLayout from '../page-layout/PageLayout';

import { Auth } from 'components/context/AuthContext';
import { ThemeProvider } from 'styled-components';
import theme, { brands } from '../../../theme.js';
import GlobalStyle from 'components/_utility/global-styles/GlobalStyles.js';
import LoadingSpinner from 'components/_common/loading-spinner';

const Page = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const slug = location.pathname === '/' ? '' : location.pathname.substring(1);
  const { handleRedirection, setNavigateFunc, page, loading, inProgress, userToken } = useContext(Auth);

  useEffect(() => {
    setNavigateFunc(() => navigate);
  }, [navigate, setNavigateFunc]);

  useEffect(() => {
    handleRedirection(slug, navigate);
  }, [slug, navigate, inProgress, userToken]);

  if (!page) {
    return <LoadingSpinner />;
  }

  const brand = page?.brand || 'default';
  const newColours = { ...theme.colours, ...brands[brand] };
  theme.colours = newColours;

  return (
    <ThemeProvider theme={theme}>
      {loading ? <LoadingSpinner /> : null}
      <GlobalStyle />
      <PageLayout {...mapPageJSON(page)} />
    </ThemeProvider>
  );
};

export default Page;
